import API_BASE_URL from '../config';
import React, { useState, useEffect } from 'react';
import { GLOBAL_CALCULATIONS } from './GlobalLogic';
// 1. Import nprogress and its CSS
import nprogress from 'nprogress';
import 'nprogress/nprogress.css';

// Configure nprogress (Optional: removes the small loading circle)
nprogress.configure({ showSpinner: false, speed: 400 });

const Ordershow = () => {
    const [orders, setOrders] = useState([]);
    const [articles, setArticles] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [statusFilter, setStatusFilter] = useState("All Status");
    const [paymentFilter, setPaymentFilter] = useState("All Payments");
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    
    const [currentPage, setCurrentPage] = useState(1);
    const ordersPerPage = 50;

    useEffect(() => {
        // Load initial data
        loadInitialData();
    }, []);

    // 2. Wrap initial fetches to show progress
    const loadInitialData = async () => {
        nprogress.start(); // Start bar
        try {
            // await Promise.all([getorders(), getArticles()]);
            await GLOBAL_CALCULATIONS.initializeData();
            setArticles(GLOBAL_CALCULATIONS.allArticles);
            setOrders(GLOBAL_CALCULATIONS.allOrders);
        } finally {
            nprogress.done(); // Stop bar
        }
    };

    // const getorders = async () => {
    //     try {
    //         const res = await fetch(`${API_BASE_URL}/ordershowa`);
    //         const data = await res.json();
    //         setOrders(data);
    //     } catch (err) {
    //         console.error("Error fetching orders:", err);
    //     }
    // };

    // const getArticles = async () => {
    //     try {
    //         let result = await fetch(`${API_BASE_URL}/articleshowa`);
    //         result = await result.json();
    //         setArticles(result);
    //     } catch (e) { 
    //         console.error("Error fetching articles:", e); 
    //     }
    // };

    const handleStatusUpdate = async (id, newStatus) => {
        nprogress.start(); // Start progress for status change
        let updateData = { odrsts: newStatus };
        try {
            let response = await fetch(`${API_BASE_URL}/update-order-status/${id}`, {
                method: "PUT",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(updateData)
            });
            if (response.ok) await loadInitialData();
        } catch (error) {
            console.error("Error updating status:", error);
        } finally {
            nprogress.done(); // Finish progress
        }
    };

    const handleToggleUpdate = async (id, currentVal, field, label) => {
        const action = currentVal ? "unmark" : "mark";
        const confirmChange = window.confirm(`Are you sure you want to ${action} this ${label} as paid?`);
        
        if (confirmChange) {
            nprogress.start(); // Start progress for toggle
            try {
                let response = await fetch(`${API_BASE_URL}/update-order-status/${id}`, {
                    method: "PUT",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ [field]: !currentVal })
                });
                if (response.ok) await loadInitialData();
            } catch (error) {
                console.error(`Error updating ${field}:`, error);
            } finally {
                nprogress.done(); // Finish progress
            }
        }
    };

    const deleteOrder = async (id) => {
        let check = window.confirm("Are you sure you want to delete this order?");
        if (check) {
            nprogress.start(); // Start progress for deletion
            try {
                let response = await fetch(`${API_BASE_URL}/delete-order/${id}`, { method: "DELETE" });
                if (response.ok) {
                    alert("Order Deleted Successfully");
                    await loadInitialData();
                }
            } catch (error) { 
                console.error("Delete error:", error); 
            } finally {
                nprogress.done(); // Finish progress
            }
        }
    };

    // --- SORTING & FILTERING LOGIC (Unchanged) ---
    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const formatDeliveryDate = (dateStr) => {
        if (!dateStr) return { day: "--", monthYear: "" };
        const date = new Date(dateStr);
        return {
            day: date.getDate(),
            monthYear: date.toLocaleDateString('en-IN', { month: 'short', year: '2-digit' })
        };
    };

    const getDueStatus = (deliveryDate) => {
        if (!deliveryDate) return { text: "", color: "", bg: "", diff: 9999 };
        const today = new Date(); today.setHours(0,0,0,0);
        const dDate = new Date(deliveryDate); dDate.setHours(0,0,0,0);
        const diffDays = Math.ceil((dDate - today) / (1000 * 60 * 60 * 24));

        if (diffDays < 0) {
            return { text: `${Math.abs(diffDays)}d OVERDUE`, color: "#fff", bg: "#dc3545", diff: diffDays };
        } else if (diffDays === 0) {
            return { text: "TODAY", color: "#fff", bg: "#8b0000", diff: diffDays };
        } else if (diffDays <= 5) {
            const colors = ["#ff4500", "#ff8c00", "#ffa500", "#ffd700", "#ffff00"];
            const textColors = diffDays <= 2 ? "#fff" : "#000";
            return { text: `${diffDays} Day${diffDays > 1 ? 's' : ''} Left`, color: textColors, bg: colors[diffDays-1], diff: diffDays };
        } else {
            return { text: `${diffDays} days left`, color: "#6c757d", bg: "transparent", diff: diffDays }; 
        }
    };

    const filteredOrders = orders.filter(order => {
        const matchesSearch = 
            order.custname?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            order.articlename?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            order.instagramid?.toLowerCase().includes(searchTerm.toLowerCase());
        
        let matchesStatus = true;
        if (statusFilter === "Not Delivered") {
            matchesStatus = order.odrsts !== "Delivered";
        } else if (statusFilter !== "All Status") {
            matchesStatus = order.odrsts === statusFilter;
        }

        const balance = (Number(order.sellingprice) || 0) - (Number(order.payrec) || 0);
        let matchesPayment = true;
        if (paymentFilter === "Unpaid Customers") matchesPayment = balance > 0;
        
        return matchesSearch && matchesStatus && matchesPayment;
    });

    const processedOrders = filteredOrders.map(order => {
        const matchedArticle = articles.find(art => art.name === order.articlename);
        const internalTotal = GLOBAL_CALCULATIONS.getOrderInternalCost(order, matchedArticle);
        const dueInfo = getDueStatus(order.dateofdelivery);
        return {
            ...order,
            calculatedProfit: Math.round(Number(((Number(order.sellingprice) || 0) - internalTotal))),
            calculatedBalance: (Number(order.sellingprice) || 0) - (Number(order.payrec) || 0),
            dateDiff: dueInfo.diff 
        };
    }).sort((a, b) => {
        if (a.odrsts === "Delivered" && b.odrsts !== "Delivered") return 1;
        if (a.odrsts !== "Delivered" && b.odrsts === "Delivered") return -1;
        return a.dateDiff - b.dateDiff;
    });

    const sortedOrders = [...processedOrders].sort((a, b) => {
        if (!sortConfig.key) return 0;
        let aValue, bValue;
        
        if (sortConfig.key === 'profit') {
            aValue = a.calculatedProfit; bValue = b.calculatedProfit;
        } else if (sortConfig.key === 'balance') {
            aValue = a.calculatedBalance; bValue = b.calculatedBalance;
        } else if (sortConfig.key === 'dateofdelivery') {
            aValue = a.dateoforder ? new Date(a.dateoforder).getTime() : 0;
            bValue = b.dateoforder ? new Date(b.dateoforder).getTime() : 0;
        } else {
            aValue = a[sortConfig.key] || "";
            bValue = b[sortConfig.key] || "";
            if (sortConfig.key === 'sellingprice') {
                aValue = Number(aValue); bValue = Number(bValue);
            }
        }

        if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
    });

    const indexOfLastOrder = currentPage * ordersPerPage;
    const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
    const currentOrders = sortedOrders.slice(indexOfFirstOrder, indexOfLastOrder);
    const totalPages = Math.ceil(sortedOrders.length / ordersPerPage);

    const totalProfit = processedOrders.reduce((sum, order) => sum + order.calculatedProfit, 0);
    const totalDueBalance = processedOrders.reduce((sum, order) => sum + order.calculatedBalance, 0);

    const SortIcon = ({ columnKey }) => {
        if (sortConfig.key !== columnKey) return <span style={{ fontSize: '10px', marginLeft: '5px', opacity: 0.3 }}>⇅</span>;
        return <span style={{ fontSize: '10px', marginLeft: '5px', color: '#0d6efd' }}>{sortConfig.direction === 'asc' ? '▲' : '▼'}</span>;
    };

    return (
        <div className="container-fluid py-5 bg-light min-vh-100">
            {/* 3. Add Custom CSS for NProgress to match your Blue Theme */}
            <style>
                {`
                    #nprogress .bar {
                        background: #0d6efd !important;
                        height: 4px !important;
                    }
                    #nprogress .peg {
                        box-shadow: 0 0 10px #0d6efd, 0 0 5px #0d6efd !important;
                    }
                    @keyframes pulse-border {
                        0% { box-shadow: 0 0 0 0px rgba(13, 110, 253, 0.4); }
                        70% { box-shadow: 0 0 0 10px rgba(13, 110, 253, 0); }
                        100% { box-shadow: 0 0 0 0px rgba(13, 110, 253, 0); }
                    }
                    .urgent-row { background-color: #f0f7ff !important; border-left: 5px solid #0d6efd !important; }
                    .ready-badge { animation: pulse-border 2s infinite; }
                    .status-select { font-size: 0.75rem; font-weight: bold; cursor: pointer; border-radius: 5px; }
                    .summary-card { background: white; border-radius: 12px; padding: 12px 20px; display: inline-flex; align-items: center; gap: 10px; border: 1px solid #e0e0e0; }
                    .pay-toggle { transform: scale(1.1); cursor: pointer; }
                    .stch-toggle:checked { background-color: #198754; border-color: #198754; }
                    .date-day { font-size: 1.2rem; font-weight: 800; line-height: 1; }
                    .date-month { font-size: 0.65rem; text-transform: uppercase; font-weight: 700; opacity: 0.8; }
                `}
            </style>

            <div className="container">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2 className="fw-bold mb-0">Order <span className="text-primary">List</span></h2>
                    <div className="d-flex gap-3">
                        <div className="summary-card shadow-sm">
                            <span className="text-muted fw-bold small">TOTAL PROFIT</span>
                            <h4 className="mb-0 fw-bold text-success">₹{totalProfit.toLocaleString('en-IN')}</h4>
                        </div>
                        <div className="summary-card shadow-sm">
                            <span className="text-muted fw-bold small">TOTAL DUE</span>
                            <h4 className="mb-0 fw-bold text-warning">₹{totalDueBalance.toLocaleString('en-IN')}</h4>
                        </div>
                    </div>
                </div>

                <div className="row g-3 align-items-center mb-4">
                    <div className="col-lg-4">
                        <input type="text" className="form-control border-0 shadow-sm py-2" placeholder="Search..." value={searchTerm} onChange={(e) => {setSearchTerm(e.target.value); setCurrentPage(1);}} />
                    </div>
                    <div className="col-lg-3">
                        <select className="form-select border-0 shadow-sm py-2 fw-bold text-primary" value={statusFilter} onChange={(e) => {setStatusFilter(e.target.value); setCurrentPage(1);}}>
                            <option value="All Status">All Status</option>
                            <option value="Not Delivered">📦 Not Delivered Yet</option>
                            <option>Order Confirmed</option><option>Fabric Recieved</option><option>Embroidery</option><option>Stiching</option><option>Ready To Ship</option><option>On Hold</option><option>Delivered</option>
                        </select>
                    </div>
                    <div className="col-lg-3">
                        <select className="form-select border-0 shadow-sm py-2 fw-bold text-success" value={paymentFilter} onChange={(e) => {setPaymentFilter(e.target.value); setCurrentPage(1);}}>
                            <option value="All Payments">All Payments</option>
                            <option value="Unpaid Customers">⚠️ Unpaid Customers</option>
                        </select>
                    </div>
                    <div className="col-lg-2 text-end">
                        <a href="/addorder" className="btn btn-primary fw-bold shadow-sm w-100 py-2">+ Add Order</a>
                    </div>
                </div>

                <div className="card border-0 shadow-sm mb-4">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-hover align-middle mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th className="ps-4">#</th>
                                        <th onClick={() => requestSort('custname')} style={{ cursor: 'pointer' }} className="text-center">Customer <SortIcon columnKey="custname" /></th>
                                        <th onClick={() => requestSort('sellingprice')} style={{ cursor: 'pointer' }}>S.Price <SortIcon columnKey="sellingprice" /></th>
                                        <th onClick={() => requestSort('profit')} style={{ cursor: 'pointer' }}>Profit <SortIcon columnKey="profit" /></th>
                                        <th onClick={() => requestSort('balance')} style={{ cursor: 'pointer' }}>Balance <SortIcon columnKey="balance" /></th>
                                        <th onClick={() => requestSort('odrsts')} style={{ cursor: 'pointer' }}>Status <SortIcon columnKey="odrsts" /></th>
                                        <th onClick={() => requestSort('dateofdelivery')} style={{ cursor: 'pointer' }}>Delivery <SortIcon columnKey="dateofdelivery" /></th>
                                        <th className="text-center">Karigar</th>
                                        <th className="text-center">Stitching</th>
                                        <th className="text-end pe-4">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentOrders.map((order, index) => {
                                        const isUrgent = order.odrsts === "Ready To Ship";
                                        const isDelivered = order.odrsts === "Delivered";
                                        const orderdate = formatDeliveryDate(order.dateoforder);
                                        const dateInfo = formatDeliveryDate(order.dateofdelivery);
                                        const due = getDueStatus(order.dateofdelivery);

                                        return (
                                            <tr key={order._id} className={isUrgent ? "urgent-row" : ""}>
                                                <td className="ps-4 text-muted small">{indexOfFirstOrder + index + 1}</td>
                                                <td className="text-center">
                                                    <div className="fw-bold text-dark">{order.custname}</div>
                                                    <small className="text-muted d-block">{order.articlename}</small>
                                                </td>
                                                <td><div className="fw-bold text-primary">₹{order.sellingprice}</div></td>
                                                <td><div className={`fw-bold ${order.calculatedProfit >= 0 ? 'text-success' : 'text-danger'}`}>₹{order.calculatedProfit}</div></td>
                                                <td><div className={`fw-bold ${order.calculatedBalance > 0 ? 'text-warning' : 'text-muted'}`}>{order.calculatedBalance > 0 ? `₹${order.calculatedBalance}` : "Cleared"}</div></td>
                                                <td>
                                                    <select 
                                                        className={`form-select form-select-sm status-select ${isUrgent ? 'bg-primary text-white ready-badge' : 'bg-light text-primary border-primary-subtle'}`}
                                                        style={{ width: '130px' }}
                                                        value={order.odrsts}
                                                        onChange={(e) => handleStatusUpdate(order._id, e.target.value)}
                                                    >
                                                        <option>Order Confirmed</option><option>Fabric Recieved</option><option>Embroidery</option><option>Stiching</option><option>Ready To Ship</option><option>On Hold</option><option>Delivered</option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center gap-2 px-2 py-1 rounded shadow-sm" style={{ backgroundColor: isDelivered ? "transparent" : due.bg, border: isDelivered ? '1px solid #eee' : 'none' }}>
                                                        <div className="text-center border-end pe-2" style={{minWidth: '45px', color: isDelivered ? "#6c757d" : due.color, borderColor: '#eee'}}>
                                                            <div className="date-day">{orderdate.day}</div>
                                                            <div className="date-month">{orderdate.monthYear}</div>
                                                        </div>
                                                        <div className="small fw-bold" style={{ color: isDelivered ? "#6c757d" : due.color, fontSize: '0.7rem' }}>
                                                            {isDelivered ? "Delivered" : due.text}<br/>
                                                            <div className='fw-bold text-wrap'>{dateInfo.day} {dateInfo.monthYear}</div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="form-check form-switch d-inline-block">
                                                        <input className="form-check-input pay-toggle" type="checkbox" role="switch" checked={!!order.paygav} onChange={() => handleToggleUpdate(order._id, order.paygav, 'paygav', 'Karigar payment')} />
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="form-check form-switch d-inline-block">
                                                        <input className="form-check-input pay-toggle stch-toggle" type="checkbox" role="switch" checked={!!order.paystch} onChange={() => handleToggleUpdate(order._id, order.paystch, 'paystch', 'Stitching payment')} />
                                                    </div>
                                                </td>
                                                <td className="text-end pe-4 text-nowrap">
                                                    <div className="btn-group shadow-sm">
                                                        <a href={`/update-order/${order._id}`} className="btn btn-sm btn-white text-warning border">Edit</a>
                                                        <button className="btn btn-sm btn-white text-danger border" onClick={() => deleteOrder(order._id)}>Del</button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {totalPages > 1 && (
                    <nav className="d-flex justify-content-center">
                        <ul className="pagination shadow-sm">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={() => setCurrentPage(prev => prev - 1)}>Previous</button>
                            </li>
                            {[...Array(totalPages)].map((_, i) => (
                                <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                                    <button className="page-link" onClick={() => setCurrentPage(i + 1)}>{i + 1}</button>
                                </li>
                            ))}
                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={() => setCurrentPage(prev => prev + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav>
                )}
            </div>
        </div>
    );
}

export default Ordershow;
